class FAQList extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("faq-item"));
    this.overlay = document.getElementById("faq-overlay");
    this.drawer = document.getElementById("faq-overlay-content");
    this.questionEl = document.getElementById("faq-overlay-question");
    this.answerEl = document.getElementById("faq-overlay-answer");
    this.closeBtn = document.getElementById("faq-overlay-close");
    this.closeContentBtn = document.getElementById("faq-overlay-close-btn");
    this.toggleBtn = this.querySelector("#faq-toggle-btn");

    this.visibleCount = parseInt(this.dataset.visibleCountItem || "3");
    this.expanded = false;
    console.log(this.dataset.visibleCountItem,"lenght");
    this.items.forEach((item) => {
      item.addEventListener("click", () => this.open(item));
    });

    this.closeBtn?.addEventListener("click", () => this.close());
    this.closeContentBtn?.addEventListener("click", () => this.close());
    this.overlay?.addEventListener("click", (e) => {
      if (e.target === this.overlay) this.close();
    });

    this.toggleBtn?.addEventListener("click", () => this.toggleShow());

    this.updateVisibleItems();
  }

  updateVisibleItems() {
    this.items.forEach((item, index) => {
      const shouldHide = !this.expanded && index >= this.visibleCount;
      item.classList.toggle("hidden", shouldHide);
    });

    this.updateLastItemBorder();

    if (this.toggleBtn) {
      this.toggleBtn.textContent = this.expanded
        ? this.dataset.lessText || "Show less"
        : this.dataset.moreText || "Show more";
      this.toggleBtn.setAttribute("aria-expanded", String(this.expanded));
    }
  }

  updateLastItemBorder() {
    this.items.forEach((item) => {
      item.style.borderBottomWidth = ""; // reset
    });

    const visibleItems = this.items.filter((item) => !item.classList.contains("hidden"));
    const lastVisibleItem = visibleItems.at(-1);

    if (lastVisibleItem) {
      lastVisibleItem.style.borderBottomWidth = "0px";
    }
  }

  toggleShow() {
    this.expanded = !this.expanded;
    this.updateVisibleItems();
  }

  open(item) {
    this.questionEl.textContent = item.dataset.question;
    this.answerEl.innerHTML = item.dataset.answer;

    this.overlay.classList.remove("hidden");
    requestAnimationFrame(() => {
      this.drawer.classList.remove("md:translate-x-full");
      this.drawer.classList.remove("md:translate-y-0");
      this.drawer.classList.remove("translate-y-full");
    });
  }

  close() {
    this.drawer.classList.add("md:translate-x-full");
    this.drawer.classList.add("md:translate-y-0");
    this.drawer.classList.add("translate-y-full");
    setTimeout(() => {
      this.overlay.classList.add("hidden");
    }, 300);
  }
}

customElements.define("faq-list", FAQList);